import script from "./Notify.vue?vue&type=script&setup=true&lang=js"
export * from "./Notify.vue?vue&type=script&setup=true&lang=js"

import "./Notify.vue?vue&type=style&index=0&id=8fbca558&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fbca558"]])

export default __exports__